import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AppService } from './services/app.service';
import { CacheService } from './services/cache.service';
import { AppUpdateService } from './services/app-update.service';

@Component({
  selector: 'dc-root',
  imports: [
    RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
    ButtonModule,
  ],
  templateUrl: './app.component.html',
  providers: [
    MessageService,
    ConfirmationService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private appUpdateService = inject(AppUpdateService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private appService = inject(AppService);
  private cacheService = inject(CacheService);
  
  ngOnInit(): void {
    const theme = localStorage.getItem('doktorijum_theme') || 'light';
    this.appService.switchTheme(theme);

    this.cacheService.load();

    this.appService.initReverb();

    this.appService
      .update
      .subscribe(
        (data: any) => {
          if (data) {
            const updateData = {
              key: 'update',
              severity: 'info',
              summary: $localize `Update Available`,
              detail: $localize `A new version of the application is available. Save your progress and reload to apply the update.`,
              life: 10000,
              sticky: true
            };
            this.messageService.add(updateData);
          }
        }
      );

    this.appService
      .toast
      .subscribe(
        (message: any) => {
          if (message) {
            this.messageService.add(message);
          }
        }
      );
      
    this.appService
      .dialog
      .subscribe(
        (dialog: any) => {
          if (dialog) {
            this.confirmationService.confirm(dialog);
          }
        }
      );
  }

  reload(): void {
    location.reload();
  }
}
